import { create } from "zustand";

const useLoaderStore = create((set) => ({
  activeRequests: 0,
  mutatingRequests: 0,
  // Number of on-page loading regions (tables showing their own skeleton).
  // While any are active the global bar stays hidden so it never doubles up.
  scopedLoaders: 0,
  showLoader: (isMutating = false) =>
    set((s) => ({
      activeRequests: s.activeRequests + 1,
      mutatingRequests: s.mutatingRequests + (isMutating ? 1 : 0),
    })),
  hideLoader: (isMutating = false) =>
    set((s) => ({
      activeRequests: Math.max(0, s.activeRequests - 1),
      mutatingRequests: Math.max(0, s.mutatingRequests - (isMutating ? 1 : 0)),
    })),
  enterScoped: () => set((s) => ({ scopedLoaders: s.scopedLoaders + 1 })),
  leaveScoped: () => set((s) => ({ scopedLoaders: Math.max(0, s.scopedLoaders - 1) })),
}));

// Callable outside React components (e.g. axios interceptors)
export const showLoader = (isMutating) => useLoaderStore.getState().showLoader(isMutating);
export const hideLoader = (isMutating) => useLoaderStore.getState().hideLoader(isMutating);

export default useLoaderStore;
